import { createTheme } from '@mui/material/styles';

const theme = createTheme({
    palette: {
        primary: {
            main:  "#002F44"
        },
        secondary: {
            main: "#FDC737"
        }
    },
    typography: {
        allVariants: {
            fontFamily: 'Nirmala'
        }
    }
  });

export default theme;